import {firstPage} from "./pagination";

export const searchDefault = Object.freeze({
  searching: false,
  pagination: firstPage,
  filters: {},
  sorter: {},
  searchFilter: '',
  results: [],
  error: null,
});

export function handleSearch(state, stateName, {pagination, filters, sorter, searchFilter}) {
  return {
    ...state,
    [stateName]: {
      ...state[stateName],
      pagination,
      filters,
      sorter,
      searchFilter,
      searching: true,
      results: [],
      error: null,
    },
  };
}

export function handleSearchCompleted(state, stateName, {results, pagination}) {
  return {
    ...state,
    [stateName]: {
      ...state[stateName],
      results,
      pagination,
      searching: false,
    }
  };
}

export function handleSearchFailed(state, stateName, error) {
  return {
    ...state,
    [stateName]: {
      ...state[stateName],
      error,
      searching: false,
      pagination: firstPage,
    }};
}


// WEBPACK FOOTER //
// ./src/utils/search.js